import Enum from '@square/dashboard-utilities/utils/enum';
export const CreateBarCodeLabelStepNames = Enum.create('CREATE_ITEM', 'SELECT_PRINT_LABELS', 'SELECT_LABEL_TYPE_AND_LOCATION', 'SELECT_ITEMS', 'CREATE_LABELS');